// conversion tracking code provided by Ontario Reign
export default function (totalCharge, quantity, card) {
  gtag("event", "conversion", {
    send_to: "AW-958473850/pv4WCOmX5vwCEPrMhMkD",
    value: totalCharge,
    currency: "USD",
    transaction_id: card?.id,
    quantity,
  });
  fbq("track", "Purchase", {
    value: totalCharge,
    currency: "USD",
    quantity,
  });
}
